var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYouricon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250 0a250 250 0 1 0 0 500 250 250 0 0 0 0-500zM52.8 316.9l51.4 26.9v54.6a207.9 207.9 0 0 1-51.4-81.5zm108.1 121.4l100.6-112.1v-69.7h-30.6s-52.1-6.9-104.7-61.9H49.4c3.2-11.5 7.4-22.7 12.5-33.5h33.6l69.9-70V59.9a207.7 207.7 0 0 1 166.1-1.6 90.3 90.3 0 0 0 56.7 160.4c2.3 0 4.7 6.7 4.7 6.7 19.9 71.1 6.8 145.8-.6 177.1a207 207 0 0 1-231.5 36.1l.1-.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouricon);
export default __webpack_public_path__ + "static/media/youricon.a867fb5c57b3a13f098867298816b86f.svg";
export { ForwardRef as ReactComponent };